import { ChevronDown } from "lucide-react";
import { useState } from "react";

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";

const PRESET_NICHES = [
    "Cooking / Gastronomy",
    "Fitness",
    "Real Estate",
    "E-commerce",
    "Personal Brand",
    "Tech / SaaS",
    "Finance",
    "Beauty & Fashion",
    "Education / Online Courses",
    "Travel",
    "Other (specify)",
];

export default function Step1Niche({ form, updateField }) {
    const [open, setOpen] = useState(false);
    const isOther = form.niche === "Other (specify)";

    return (
        <div
            className="flex flex-col gap-6"
            data-testid="strategy-step-1"
        >
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-[#E8ECF5]">
                    What's your industry or niche?
                </h3>
                <p className="font-mono text-[11px] italic text-[#8A93A6]">
                    Pulse uses this to anchor every post hook, platform routing,
                    and hashtag choice.
                </p>
            </div>

            <div className="flex flex-col gap-3">
                <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                    niche
                </label>
                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild>
                        <button
                            type="button"
                            className="group flex items-center justify-between gap-2 rounded-xl border border-[#1F2A40] bg-[#111726] px-4 py-3 text-left text-sm text-[#E8ECF5] transition-all hover:border-[#00F5D4]/50 focus:border-[#2F58CD] focus:outline-none"
                            data-testid="strategy-niche-trigger"
                        >
                            <span
                                className={
                                    form.niche ? "text-[#E8ECF5]" : "text-[#8A93A6]"
                                }
                            >
                                {form.niche || "Pick a niche or type your own…"}
                            </span>
                            <ChevronDown
                                className={[
                                    "h-4 w-4 text-[#8A93A6] transition-transform",
                                    open && "rotate-180",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            />
                        </button>
                    </PopoverTrigger>
                    <PopoverContent
                        align="start"
                        className="z-50 w-[var(--radix-popover-trigger-width)] max-h-[280px] overflow-y-auto border-[#1F2A40] bg-[#111726] p-1 text-[#E8ECF5]"
                        data-testid="strategy-niche-popover"
                    >
                        {PRESET_NICHES.map((n) => (
                            <button
                                key={n}
                                type="button"
                                onClick={() => {
                                    updateField("niche", n);
                                    setOpen(false);
                                }}
                                data-testid={`strategy-niche-opt-${n.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                data-selected={
                                    form.niche === n ? "true" : "false"
                                }
                                className={[
                                    "flex w-full items-center rounded-md px-3 py-2 text-sm transition-colors",
                                    form.niche === n
                                        ? "bg-[#1A2235] text-[#00F5D4]"
                                        : "text-[#E8ECF5] hover:bg-[#1A2235]",
                                ].join(" ")}
                            >
                                {n}
                            </button>
                        ))}
                    </PopoverContent>
                </Popover>

                {isOther && (
                    <div className="flex flex-col gap-2">
                        <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                            specify
                        </label>
                        <input
                            type="text"
                            value={form.niche_other}
                            onChange={(e) =>
                                updateField("niche_other", e.target.value)
                            }
                            placeholder="e.g. Woodworking · Pet grooming · Indie game dev…"
                            data-testid="strategy-niche-other-input"
                            className="w-full rounded-xl border border-[#1F2A40] bg-[#111726] px-4 py-3 text-sm text-[#E8ECF5] placeholder:text-[#8A93A6] transition-all focus:border-[#2F58CD] focus:outline-none focus:ring-1 focus:ring-[#2F58CD]/40"
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
